<script lang="ts" setup>
import { useIsCrowdfunding } from "~/composables/useIsCrowdfunding";

const { $tt } = useNuxtApp();
const isCrowdfunding = useIsCrowdfunding();
</script>

<template>
  <div class="h-screen justify-center py-8 px-10">
    <div class="pt-20">
      <div class="h-auto gap-8 grid max-xl:justify-center w-full xl:w-[600px]">
        <div
          class="font-poppins text-5xl w-full text-zinc-100 gap-3 grid py-2 font-bold"
        >
          <p>{{ $tt("landing.hero.title1") }}</p>
          <p
            class="bg-primary pr-2 w-fit text-black h-auto leading-10 pb-2 pt-1 font-extrabold self-stretch"
          >
            {{
              isCrowdfunding
                ? $tt("landing.hero.title3Cr")
                : $tt("landing.hero.title3")
            }}
          </p>
        </div>
        <div class="text-start text-xl font-Roboto text-white gap-4 grid">
          <div class="flex gap-2">
            <div class="w-1 h-7 bg-amber-300" />
            <p>{{ $tt("landing.hero.bulletpoints.0") }}</p>
          </div>
          <div class="flex gap-2">
            <div class="w-1 h-7 bg-amber-300" />
            <p>{{ $tt("landing.hero.bulletpoints.1") }}</p>
          </div>
          <div class="flex gap-2">
            <div class="w-1 h-7 bg-amber-300" />
            <p>{{ $tt("landing.hero.bulletpoints.2") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
